import * as React from 'react';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { useEffect, useState } from 'react';
import { IProtocol, IRiferimentoSeguito } from '../../../../../shared/interfaces';
import protocolReferencesSercice from '../../../../../services/protocolReferences.service';
import { RootState } from '../../../../../store';
import { useSelector } from 'react-redux';
import {
    Label, Link, Text, List, DocumentCard, DocumentCardDetails, DocumentCardActions,
    DocumentCardType, IDocumentCardStyles, IButtonProps, Dialog, DialogType,
    DialogFooter, PrimaryButton, DefaultButton, getTheme, ITheme
} from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import abilityBuild from '../../../../../shared/CASL/appAbility';
import { subject } from "@casl/ability";
import { Protocol_State } from '../../../../../shared/enums';
import { mergeStyleSets } from '@fluentui/merge-styles';
import { RouteComponentProps } from 'react-router-dom';
import { ToastMessageType } from 'primereact/toast';

const theme: ITheme = getTheme();
const { fonts } = theme;


const documentCardSyles: Partial<IDocumentCardStyles> = {
    root: {
        height: 50,
        '& .ms-DocumentCardDetails': {

            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '0 15px'
        },
        '& .ms-DocumentCardActions': {

            display: 'flex', flexFlow: 'column', justifyContent: 'center', 'height': 'unset'
        }

    },

}

const classNames = mergeStyleSets({
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
            

        },
    ],
    label: {
        paddingLeft: 25,
        paddingRight: 25
    },
    loader: {
        'z-index': 999999999999
    }
});

export interface ProtocolReferencesProps {
    protocol: IProtocol
    forceProtocolReferencesRefresh: boolean
    extraCssClass?: string
    onDeleteReference: (deleteMessage: ToastMessageType) => void
}
type Props = ProtocolReferencesProps & RouteComponentProps

const ProtocolReferences: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);


    const [loading, { setFalse: hideLoading, setTrue: showLoading }] = useBoolean(false);
    const [riferimenti, setRiferimenti] = useState<IRiferimentoSeguito[]>([]);
    const [seguiti, setSeguiti] = useState<IRiferimentoSeguito[]>([]);

    const [isConfirmDialogOpen, { setTrue: showConfirmDialog, setFalse: dismissConfirmDialog }] = useBoolean(false);
    const [submitConfirmDialog, setSubmitConfirmDialog] = useState(() => () => { });



    useEffect(() => {
        showLoading();
        protocolReferencesSercice.getRiferimentiSeguitiProtocollo(currentAoo!.id, currentUor?.id, props.protocol.protocolId!)
            .then(result => {
                setRiferimenti(result.riferimenti);
                setSeguiti(result.seguiti);
                hideLoading();
            });
    }, [props.forceProtocolReferencesRefresh])



    const deleteReferenceConfirmDialogSubmit = (ev, item: IRiferimentoSeguito) => {
        showLoading();
        protocolReferencesSercice.deleteReference(currentAoo!.id, currentUor!.id!, item.id, item.id)
            .then(result => {
                //non faccio hideLoading qua perchè in props.onDeleteReference forzo il reload dei riferimenti
                props.onDeleteReference({ severity: 'info', summary: `Riferimento ${item.protocolText}`, detail: "Eliminato correttamente", life: 5000 });

            }, error => {
                props.onDeleteReference({ severity: 'error', summary: 'Attezione', detail: "Errore nella rimozione del riferimento", life: 5000 });

            });
        dismissConfirmDialog();

    }

    const abortConfirmDialog = () => {
        setSubmitConfirmDialog(() => () => { })
        dismissConfirmDialog();
    }


    const onRenderReferenceCell = (item, isRiferimento:boolean) => {
        let protocolReference = { ...item } as IRiferimentoSeguito;
        let actions: IButtonProps[] = [];
        let path;

        if (props.protocol && props.protocol.statoProtocollo === Protocol_State.Protocollato
            && abilityBuild.can('update', subject('IProtocol', props.protocol))
            && isRiferimento) {
            actions.push(
                {
                    iconProps: { iconName: 'Delete' },
                    onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        setSubmitConfirmDialog(() => () => { deleteReferenceConfirmDialogSubmit(ev, protocolReference) })
                        showConfirmDialog()
                    },
                    ariaLabel: 'Elimina',
                }
            );
        }
            path = `/${currentAoo?.id}/${protocolReference.id}/${protocolReference.protocolText.replace('/', '-')}`;



        return (
            <DocumentCard
                type={DocumentCardType.compact}
                styles={documentCardSyles}

            >
                <DocumentCardDetails >
                    <Link id={protocolReference.id.toString() }
                        className={classNames.itemName}
                        onClick={() => {
                            props.history.push({ pathname: path, search: props.location.search });
                        }
                        }>
                        {protocolReference.protocolText}
                    </Link>

                </DocumentCardDetails>
                <DocumentCardActions
                    actions={actions} />

            </DocumentCard>
        );
    }

    return (
        <div className={`protocol-references flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={`references-box flex flex-column overflow-hidden`} >
                <Label className={classNames.label}>Riferimenti</Label>
                <div className={`position-relative my-scroll-div`}>
                    <div className={`my-component-content`}>
                        {
                            riferimenti && riferimenti.length > 0
                                ?
                                <List items={riferimenti} onRenderCell={(item) => onRenderReferenceCell(item, true)} />
                                :
                                <div style={{ marginLeft: '31px' }}>
                                    <Text> Nessun riferimento inserito</Text>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className={`references-box flex flex-column overflow-hidden`} >
                <Label className={classNames.label}>Seguiti</Label>
                <div className={`position-relative my-scroll-div`}>
                    <div className={`my-component-content`}>
                        {
                            seguiti && seguiti.length > 0
                                ?
                                <List items={seguiti} onRenderCell={(item) => onRenderReferenceCell(item, false)} />
                                :
                                <div style={{ marginLeft: '31px' }}>
                                    <Text> Nessun seguito del protocollo</Text>
                                </div>
                        }
                    </div>
                </div>
            </div>

            <Dialog
                hidden={!isConfirmDialogOpen}
                onDismiss={abortConfirmDialog}
                dialogContentProps={{

                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi rimuovere il riferimento?`,
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={submitConfirmDialog} text="Conferma" />
                    <DefaultButton onClick={abortConfirmDialog} text="Annulla" />
                </DialogFooter>

            </Dialog>

        </ div>

    );
};


export default ProtocolReferences;
